import { NgModule } from '@angular/core';

import { AdminReportSystemErrorLogsComponent } from './admin-reports.system-error-logs.component';
import { SharedModule }                        from '../../shared/shared.module';

@NgModule({
  declarations: [
    AdminReportSystemErrorLogsComponent
  ],
  entryComponents: [
    AdminReportSystemErrorLogsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AdminReportsModule {}
